import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TeacherPage = lazy(() => import('../pages/teacher/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/service',
    element: <ServicePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/teacher',
    element: <TeacherPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;